export const countries = {
  GS: {
    label: "South Georgia",
    iso2: "GS",
  },
  GD: {
    label: "Grenada",
    iso2: "GD",
  },
  CH: {
    label: "Switzerland",
    iso2: "CH",
  },
  SL: {
    label: "Sierra Leone",
    iso2: "SL",
  },
  HU: {
    label: "Hungary",
    iso2: "HU",
  },
  TW: {
    label: "Taiwan",
    iso2: "TW",
  },
  WF: {
    label: "Wallis and Futuna",
    iso2: "WF",
  },
  BB: {
    label: "Barbados",
    iso2: "BB",
  },
  PN: {
    label: "Pitcairn Islands",
    iso2: "PN",
  },
  CI: {
    label: "Ivory Coast",
    iso2: "CI",
  },
  TN: {
    label: "Tunisia",
    iso2: "TN",
  },
  IT: {
    label: "Italy",
    iso2: "IT",
  },
  BJ: {
    label: "Benin",
    iso2: "BJ",
  },
  ID: {
    label: "Indonesia",
    iso2: "ID",
  },
  CV: {
    label: "Cape Verde",
    iso2: "CV",
  },
  KN: {
    label: "Saint Kitts and Nevis",
    iso2: "KN",
  },
  LA: {
    label: "Laos",
    iso2: "LA",
  },
  BQ: {
    label: "Caribbean Netherlands",
    iso2: "BQ",
  },
  UG: {
    label: "Uganda",
    iso2: "UG",
  },
  AD: {
    label: "Andorra",
    iso2: "AD",
  },
  BI: {
    label: "Burundi",
    iso2: "BI",
  },
  ZA: {
    label: "South Africa",
    iso2: "ZA",
  },
  FR: {
    label: "France",
    iso2: "FR",
  },
  LY: {
    label: "Libya",
    iso2: "LY",
  },
  MX: {
    label: "Mexico",
    iso2: "MX",
  },
  GA: {
    label: "Gabon",
    iso2: "GA",
  },
  MP: {
    label: "Northern Mariana Islands",
    iso2: "MP",
  },
  MK: {
    label: "North Macedonia",
    iso2: "MK",
  },
  CN: {
    label: "China",
    iso2: "CN",
  },
  YE: {
    label: "Yemen",
    iso2: "YE",
  },
  BL: {
    label: "Saint Barthélemy",
    iso2: "BL",
  },
  GG: {
    label: "Guernsey",
    iso2: "GG",
  },
  SB: {
    label: "Solomon Islands",
    iso2: "SB",
  },
  SJ: {
    label: "Svalbard and Jan Mayen",
    iso2: "SJ",
  },
  FO: {
    label: "Faroe Islands",
    iso2: "FO",
  },
  UZ: {
    label: "Uzbekistan",
    iso2: "UZ",
  },
  EG: {
    label: "Egypt",
    iso2: "EG",
  },
  SN: {
    label: "Senegal",
    iso2: "SN",
  },
  LK: {
    label: "Sri Lanka",
    iso2: "LK",
  },
  PS: {
    label: "Palestine",
    iso2: "PS",
  },
  BD: {
    label: "Bangladesh",
    iso2: "BD",
  },
  PE: {
    label: "Peru",
    iso2: "PE",
  },
  SG: {
    label: "Singapore",
    iso2: "SG",
  },
  TR: {
    label: "Turkey",
    iso2: "TR",
  },
  AF: {
    label: "Afghanistan",
    iso2: "AF",
  },
  AW: {
    label: "Aruba",
    iso2: "AW",
  },
  CK: {
    label: "Cook Islands",
    iso2: "CK",
  },
  GB: {
    label: "United Kingdom",
    iso2: "GB",
  },
  ZM: {
    label: "Zambia",
    iso2: "ZM",
  },
  FI: {
    label: "Finland",
    iso2: "FI",
  },
  NE: {
    label: "Niger",
    iso2: "NE",
  },
  CX: {
    label: "Christmas Island",
    iso2: "CX",
  },
  TK: {
    label: "Tokelau",
    iso2: "TK",
  },
  GW: {
    label: "Guinea-Bissau",
    iso2: "GW",
  },
  AZ: {
    label: "Azerbaijan",
    iso2: "AZ",
  },
  RE: {
    label: "Réunion",
    iso2: "RE",
  },
  DJ: {
    label: "Djibouti",
    iso2: "DJ",
  },
  KP: {
    label: "North Korea",
    iso2: "KP",
  },
  MU: {
    label: "Mauritius",
    iso2: "MU",
  },
  MS: {
    label: "Montserrat",
    iso2: "MS",
  },
  VI: {
    label: "United States Virgin Islands",
    iso2: "VI",
  },
  CO: {
    label: "Colombia",
    iso2: "CO",
  },
  GR: {
    label: "Greece",
    iso2: "GR",
  },
  HR: {
    label: "Croatia",
    iso2: "HR",
  },
  MA: {
    label: "Morocco",
    iso2: "MA",
  },
  DZ: {
    label: "Algeria",
    iso2: "DZ",
  },
  AQ: {
    label: "Antarctica",
    iso2: "AQ",
  },
  NL: {
    label: "Netherlands",
    iso2: "NL",
  },
  SD: {
    label: "Sudan",
    iso2: "SD",
  },
  FJ: {
    label: "Fiji",
    iso2: "FJ",
  },
  LI: {
    label: "Liechtenstein",
    iso2: "LI",
  },
  NP: {
    label: "Nepal",
    iso2: "NP",
  },
  PR: {
    label: "Puerto Rico",
    iso2: "PR",
  },
  GE: {
    label: "Georgia",
    iso2: "GE",
  },
  PK: {
    label: "Pakistan",
    iso2: "PK",
  },
  MC: {
    label: "Monaco",
    iso2: "MC",
  },
  BW: {
    label: "Botswana",
    iso2: "BW",
  },
  LB: {
    label: "Lebanon",
    iso2: "LB",
  },
  PG: {
    label: "Papua New Guinea",
    iso2: "PG",
  },
  YT: {
    label: "Mayotte",
    iso2: "YT",
  },
  DO: {
    label: "Dominican Republic",
    iso2: "DO",
  },
  NF: {
    label: "Norfolk Island",
    iso2: "NF",
  },
  BV: {
    label: "Bouvet Island",
    iso2: "BV",
  },
  QA: {
    label: "Qatar",
    iso2: "QA",
  },
  MG: {
    label: "Madagascar",
    iso2: "MG",
  },
  IN: {
    label: "India",
    iso2: "IN",
  },
  SY: {
    label: "Syria",
    iso2: "SY",
  },
  ME: {
    label: "Montenegro",
    iso2: "ME",
  },
  SZ: {
    label: "Eswatini",
    iso2: "SZ",
  },
  PY: {
    label: "Paraguay",
    iso2: "PY",
  },
  SV: {
    label: "El Salvador",
    iso2: "SV",
  },
  UA: {
    label: "Ukraine",
    iso2: "UA",
  },
  IM: {
    label: "Isle of Man",
    iso2: "IM",
  },
  NA: {
    label: "Namibia",
    iso2: "NA",
  },
  AE: {
    label: "United Arab Emirates",
    iso2: "AE",
  },
  BG: {
    label: "Bulgaria",
    iso2: "BG",
  },
  GL: {
    label: "Greenland",
    iso2: "GL",
  },
  DE: {
    label: "Germany",
    iso2: "DE",
  },
  KH: {
    label: "Cambodia",
    iso2: "KH",
  },
  IQ: {
    label: "Iraq",
    iso2: "IQ",
  },
  TF: {
    label: "French Southern and Antarctic Lands",
    iso2: "TF",
  },
  SE: {
    label: "Sweden",
    iso2: "SE",
  },
  CU: {
    label: "Cuba",
    iso2: "CU",
  },
  KG: {
    label: "Kyrgyzstan",
    iso2: "KG",
  },
  RU: {
    label: "Russia",
    iso2: "RU",
  },
  MY: {
    label: "Malaysia",
    iso2: "MY",
  },
  ST: {
    label: "São Tomé and Príncipe",
    iso2: "ST",
  },
  CY: {
    label: "Cyprus",
    iso2: "CY",
  },
  CA: {
    label: "Canada",
    iso2: "CA",
  },
  MW: {
    label: "Malawi",
    iso2: "MW",
  },
  SA: {
    label: "Saudi Arabia",
    iso2: "SA",
  },
  BA: {
    label: "Bosnia and Herzegovina",
    iso2: "BA",
  },
  ET: {
    label: "Ethiopia",
    iso2: "ET",
  },
  ES: {
    label: "Spain",
    iso2: "ES",
  },
  SI: {
    label: "Slovenia",
    iso2: "SI",
  },
  OM: {
    label: "Oman",
    iso2: "OM",
  },
  PM: {
    label: "Saint Pierre and Miquelon",
    iso2: "PM",
  },
  MO: {
    label: "Macau",
    iso2: "MO",
  },
  SM: {
    label: "San Marino",
    iso2: "SM",
  },
  LS: {
    label: "Lesotho",
    iso2: "LS",
  },
  MH: {
    label: "Marshall Islands",
    iso2: "MH",
  },
  SX: {
    label: "Sint Maarten",
    iso2: "SX",
  },
  IS: {
    label: "Iceland",
    iso2: "IS",
  },
  LU: {
    label: "Luxembourg",
    iso2: "LU",
  },
  AR: {
    label: "Argentina",
    iso2: "AR",
  },
  TC: {
    label: "Turks and Caicos Islands",
    iso2: "TC",
  },
  NR: {
    label: "Nauru",
    iso2: "NR",
  },
  CC: {
    label: "Cocos (Keeling) Islands",
    iso2: "CC",
  },
  EH: {
    label: "Western Sahara",
    iso2: "EH",
  },
  DM: {
    label: "Dominica",
    iso2: "DM",
  },
  CR: {
    label: "Costa Rica",
    iso2: "CR",
  },
  AU: {
    label: "Australia",
    iso2: "AU",
  },
  TH: {
    label: "Thailand",
    iso2: "TH",
  },
  HT: {
    label: "Haiti",
    iso2: "HT",
  },
  TV: {
    label: "Tuvalu",
    iso2: "TV",
  },
  HN: {
    label: "Honduras",
    iso2: "HN",
  },
  GQ: {
    label: "Equatorial Guinea",
    iso2: "GQ",
  },
  LC: {
    label: "Saint Lucia",
    iso2: "LC",
  },
  PF: {
    label: "French Polynesia",
    iso2: "PF",
  },
  BY: {
    label: "Belarus",
    iso2: "BY",
  },
  LV: {
    label: "Latvia",
    iso2: "LV",
  },
  PW: {
    label: "Palau",
    iso2: "PW",
  },
  GP: {
    label: "Guadeloupe",
    iso2: "GP",
  },
  PH: {
    label: "Philippines",
    iso2: "PH",
  },
  GI: {
    label: "Gibraltar",
    iso2: "GI",
  },
  DK: {
    label: "Denmark",
    iso2: "DK",
  },
  CM: {
    label: "Cameroon",
    iso2: "CM",
  },
  GN: {
    label: "Guinea",
    iso2: "GN",
  },
  BH: {
    label: "Bahrain",
    iso2: "BH",
  },
  SR: {
    label: "Suriname",
    iso2: "SR",
  },
  CD: {
    label: "DR Congo",
    iso2: "CD",
  },
  SO: {
    label: "Somalia",
    iso2: "SO",
  },
  CZ: {
    label: "Czechia",
    iso2: "CZ",
  },
  NC: {
    label: "New Caledonia",
    iso2: "NC",
  },
  VU: {
    label: "Vanuatu",
    iso2: "VU",
  },
  SH: {
    label: "Saint Helena, Ascension and Tristan da Cunha",
    iso2: "SH",
  },
  TG: {
    label: "Togo",
    iso2: "TG",
  },
  VG: {
    label: "British Virgin Islands",
    iso2: "VG",
  },
  KE: {
    label: "Kenya",
    iso2: "KE",
  },
  NU: {
    label: "Niue",
    iso2: "NU",
  },
  HM: {
    label: "Heard Island and McDonald Islands",
    iso2: "HM",
  },
  RW: {
    label: "Rwanda",
    iso2: "RW",
  },
  EE: {
    label: "Estonia",
    iso2: "EE",
  },
  RO: {
    label: "Romania",
    iso2: "RO",
  },
  TT: {
    label: "Trinidad and Tobago",
    iso2: "TT",
  },
  GY: {
    label: "Guyana",
    iso2: "GY",
  },
  TL: {
    label: "Timor-Leste",
    iso2: "TL",
  },
  VN: {
    label: "Vietnam",
    iso2: "VN",
  },
  UY: {
    label: "Uruguay",
    iso2: "UY",
  },
  VA: {
    label: "Vatican City",
    iso2: "VA",
  },
  HK: {
    label: "Hong Kong",
    iso2: "HK",
  },
  AT: {
    label: "Austria",
    iso2: "AT",
  },
  AG: {
    label: "Antigua and Barbuda",
    iso2: "AG",
  },
  TM: {
    label: "Turkmenistan",
    iso2: "TM",
  },
  MZ: {
    label: "Mozambique",
    iso2: "MZ",
  },
  PA: {
    label: "Panama",
    iso2: "PA",
  },
  FM: {
    label: "Micronesia",
    iso2: "FM",
  },
  IE: {
    label: "Ireland",
    iso2: "IE",
  },
  CW: {
    label: "Curaçao",
    iso2: "CW",
  },
  GF: {
    label: "French Guiana",
    iso2: "GF",
  },
  NO: {
    label: "Norway",
    iso2: "NO",
  },
  AX: {
    label: "Åland Islands",
    iso2: "AX",
  },
  CF: {
    label: "Central African Republic",
    iso2: "CF",
  },
  BF: {
    label: "Burkina Faso",
    iso2: "BF",
  },
  ER: {
    label: "Eritrea",
    iso2: "ER",
  },
  TZ: {
    label: "Tanzania",
    iso2: "TZ",
  },
  KR: {
    label: "South Korea",
    iso2: "KR",
  },
  JO: {
    label: "Jordan",
    iso2: "JO",
  },
  MR: {
    label: "Mauritania",
    iso2: "MR",
  },
  LT: {
    label: "Lithuania",
    iso2: "LT",
  },
  UM: {
    label: "United States Minor Outlying Islands",
    iso2: "UM",
  },
  SK: {
    label: "Slovakia",
    iso2: "SK",
  },
  AO: {
    label: "Angola",
    iso2: "AO",
  },
  KZ: {
    label: "Kazakhstan",
    iso2: "KZ",
  },
  MD: {
    label: "Moldova",
    iso2: "MD",
  },
  ML: {
    label: "Mali",
    iso2: "ML",
  },
  FK: {
    label: "Falkland Islands",
    iso2: "FK",
  },
  AM: {
    label: "Armenia",
    iso2: "AM",
  },
  WS: {
    label: "Samoa",
    iso2: "WS",
  },
  JE: {
    label: "Jersey",
    iso2: "JE",
  },
  JP: {
    label: "Japan",
    iso2: "JP",
  },
  BO: {
    label: "Bolivia",
    iso2: "BO",
  },
  CL: {
    label: "Chile",
    iso2: "CL",
  },
  US: {
    label: "United States",
    iso2: "US",
  },
  VC: {
    label: "Saint Vincent and the Grenadines",
    iso2: "VC",
  },
  BM: {
    label: "Bermuda",
    iso2: "BM",
  },
  SC: {
    label: "Seychelles",
    iso2: "SC",
  },
  IO: {
    label: "British Indian Ocean Territory",
    iso2: "IO",
  },
  GT: {
    label: "Guatemala",
    iso2: "GT",
  },
  EC: {
    label: "Ecuador",
    iso2: "EC",
  },
  MQ: {
    label: "Martinique",
    iso2: "MQ",
  },
  TJ: {
    label: "Tajikistan",
    iso2: "TJ",
  },
  MT: {
    label: "Malta",
    iso2: "MT",
  },
  GM: {
    label: "Gambia",
    iso2: "GM",
  },
  NG: {
    label: "Nigeria",
    iso2: "NG",
  },
  BS: {
    label: "Bahamas",
    iso2: "BS",
  },
  XK: {
    label: "Kosovo",
    iso2: "XK",
  },
  KW: {
    label: "Kuwait",
    iso2: "KW",
  },
  MV: {
    label: "Maldives",
    iso2: "MV",
  },
  SS: {
    label: "South Sudan",
    iso2: "SS",
  },
  IR: {
    label: "Iran",
    iso2: "IR",
  },
  AL: {
    label: "Albania",
    iso2: "AL",
  },
  BR: {
    label: "Brazil",
    iso2: "BR",
  },
  RS: {
    label: "Serbia",
    iso2: "RS",
  },
  BZ: {
    label: "Belize",
    iso2: "BZ",
  },
  MM: {
    label: "Myanmar",
    iso2: "MM",
  },
  BT: {
    label: "Bhutan",
    iso2: "BT",
  },
  VE: {
    label: "Venezuela",
    iso2: "VE",
  },
  LR: {
    label: "Liberia",
    iso2: "LR",
  },
  JM: {
    label: "Jamaica",
    iso2: "JM",
  },
  PL: {
    label: "Poland",
    iso2: "PL",
  },
  KY: {
    label: "Cayman Islands",
    iso2: "KY",
  },
  BN: {
    label: "Brunei",
    iso2: "BN",
  },
  KM: {
    label: "Comoros",
    iso2: "KM",
  },
  GU: {
    label: "Guam",
    iso2: "GU",
  },
  TO: {
    label: "Tonga",
    iso2: "TO",
  },
  KI: {
    label: "Kiribati",
    iso2: "KI",
  },
  GH: {
    label: "Ghana",
    iso2: "GH",
  },
  TD: {
    label: "Chad",
    iso2: "TD",
  },
  ZW: {
    label: "Zimbabwe",
    iso2: "ZW",
  },
  MF: {
    label: "Saint Martin",
    iso2: "MF",
  },
  MN: {
    label: "Mongolia",
    iso2: "MN",
  },
  PT: {
    label: "Portugal",
    iso2: "PT",
  },
  AS: {
    label: "American Samoa",
    iso2: "AS",
  },
  CG: {
    label: "Republic of the Congo",
    iso2: "CG",
  },
  BE: {
    label: "Belgium",
    iso2: "BE",
  },
  IL: {
    label: "Israel",
    iso2: "IL",
  },
  NZ: {
    label: "New Zealand",
    iso2: "NZ",
  },
  NI: {
    label: "Nicaragua",
    iso2: "NI",
  },
  AI: {
    label: "Anguilla",
    iso2: "AI",
  },
  YU: {
    label: "Yugoslavia",
    iso2: "YU",
  },
  S1: {
    label: "Serbia and Montenegro",
    iso2: "S1",
  },
  SU: {
    label: "USSR",
    iso2: "SU",
  },
}
